var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12","sm":"10","md":"8"}},[_c('h1',[_vm._v("Page Not Found")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }